import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h2", null, "Application management", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "text-medium-emphasis text-caption" }, "Tab order", -1)
const _hoisted_3 = { class: "d-flex" }
const _hoisted_4 = { class: "d-flex" }
const _hoisted_5 = { class: "text-caption font-weight-bold" }
const _hoisted_6 = {
  key: 0,
  class: "text-caption"
}
const _hoisted_7 = { key: 0 }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-error" }, "This application cannot be removed, because it has active tenants assigned to it. You can unassign the application from the tenants, and try again.")
], -1)
const _hoisted_9 = { class: "text-center mt-4" }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-error" }, "This application cannot be removed, because it is a sub-application within a hybrid application. Remove it from any hybrid applications, and try again.")
], -1)
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = { key: 2 }
const _hoisted_14 = { class: "text-capitalize" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { key: 1 }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("p", { class: "text-medium-emphasis text-caption" }, "Tab order", -1)
const _hoisted_18 = { class: "d-flex" }
const _hoisted_19 = { class: "d-flex" }
const _hoisted_20 = { class: "text-caption font-weight-bold" }
const _hoisted_21 = {
  key: 0,
  class: "text-caption"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_draggable = _resolveComponent("draggable")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_textarea = _resolveComponent("v-textarea")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_v_ace_editor = _resolveComponent("v-ace-editor")!
  const _component_v_window = _resolveComponent("v-window")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_data_table = _resolveComponent("v-data-table")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_v_row, {
      class: "pt-2 mx-4",
      justify: "space-between",
      align: "center",
      dense: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, {
          cols: "12",
          md: "6"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_row, {
              align: "center",
              dense: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, { cols: "12" }, {
                  default: _withCtx(() => [
                    _hoisted_1
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, { cols: "12" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_row, { dense: "" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, {
                          cols: "4",
                          md: "auto"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_dialog, {
                              modelValue: _ctx.registerDialog,
                              "onUpdate:modelValue": [
                                _cache[10] || (_cache[10] = ($event: any) => ((_ctx.registerDialog) = $event)),
                                _cache[11] || (_cache[11] = ($event: any) => {_ctx.app = { name: '', type: '', description: '', details: {}}; _ctx.tab = 'details'; _ctx.hybridApps = []; _ctx.noderedInstance = null})
                              ],
                              width: "500"
                            }, {
                              activator: _withCtx(({ props }) => [
                                _createVNode(_component_v_btn, _mergeProps(props, {
                                  size: "small",
                                  width: "220",
                                  variant: "tonal",
                                  color: "primary"
                                }), {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_icon, {
                                      icon: "mdi-plus-box",
                                      start: ""
                                    }),
                                    _createTextVNode(" " + _toDisplayString(_ctx.mdAndUp ? 'Register application' : 'Register'), 1)
                                  ]),
                                  _: 2
                                }, 1040)
                              ]),
                              default: _withCtx(({ isActive }) => [
                                _createVNode(_component_v_card, { title: "Register an application" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_tabs, {
                                      modelValue: _ctx.tab,
                                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.tab) = $event)),
                                      disabled: !_ctx.app.type
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_tab, { value: "details" }, {
                                          default: _withCtx(() => [
                                            _createTextVNode("Details")
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_v_tab, { value: "config" }, {
                                          default: _withCtx(() => [
                                            _createTextVNode("Configuration")
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue", "disabled"]),
                                    _createVNode(_component_v_card_text, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_window, {
                                          modelValue: _ctx.tab,
                                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.tab) = $event))
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_window_item, { value: "details" }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_form, null, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_row, null, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_v_col, {
                                                          cols: "12",
                                                          md: "6"
                                                        }, {
                                                          default: _withCtx(() => [
                                                            _createVNode(_component_v_text_field, {
                                                              "hide-details": "",
                                                              density: "comfortable",
                                                              label: "Name",
                                                              modelValue: _ctx.app.name,
                                                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.app.name) = $event))
                                                            }, null, 8, ["modelValue"])
                                                          ]),
                                                          _: 1
                                                        }),
                                                        _createVNode(_component_v_col, {
                                                          cols: "12",
                                                          md: "6"
                                                        }, {
                                                          default: _withCtx(() => [
                                                            _createVNode(_component_v_select, {
                                                              "hide-details": "",
                                                              density: "comfortable",
                                                              label: "Type of application",
                                                              modelValue: _ctx.app.type,
                                                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.app.type) = $event)),
                                                              items: _ctx.appTypes,
                                                              "item-title": "name",
                                                              "item-value": "type"
                                                            }, null, 8, ["modelValue", "items"])
                                                          ]),
                                                          _: 1
                                                        }),
                                                        (_ctx.app.type === 'nodered')
                                                          ? (_openBlock(), _createBlock(_component_v_col, {
                                                              key: 0,
                                                              cols: "12"
                                                            }, {
                                                              default: _withCtx(() => [
                                                                _createVNode(_component_v_select, {
                                                                  "hide-details": "",
                                                                  density: "comfortable",
                                                                  label: "Node-RED instance",
                                                                  "return-object": "",
                                                                  modelValue: _ctx.noderedInstance,
                                                                  "onUpdate:modelValue": [
                                                                    _cache[3] || (_cache[3] = ($event: any) => ((_ctx.noderedInstance) = $event)),
                                                                    _cache[4] || (_cache[4] = ($event: any) => (_ctx.updateConfiguration(_ctx.app)))
                                                                  ],
                                                                  items: _ctx.noderedInstances,
                                                                  "item-title": "name",
                                                                  "item-value": "id"
                                                                }, null, 8, ["modelValue", "items"])
                                                              ]),
                                                              _: 1
                                                            }))
                                                          : _createCommentVNode("", true),
                                                        (_ctx.app.type === 'hybrid')
                                                          ? (_openBlock(), _createBlock(_component_v_col, {
                                                              key: 1,
                                                              cols: "12"
                                                            }, {
                                                              default: _withCtx(() => [
                                                                _createVNode(_component_v_select, {
                                                                  multiple: "",
                                                                  "hide-details": "",
                                                                  density: "comfortable",
                                                                  label: "Applications to group",
                                                                  "return-object": "",
                                                                  modelValue: _ctx.hybridApps,
                                                                  "onUpdate:modelValue": [
                                                                    _cache[5] || (_cache[5] = ($event: any) => ((_ctx.hybridApps) = $event)),
                                                                    _cache[6] || (_cache[6] = ($event: any) => (_ctx.updateConfiguration(_ctx.app)))
                                                                  ],
                                                                  items: _ctx.hybridAvailableApps,
                                                                  "item-title": "name",
                                                                  "item-value": "id"
                                                                }, null, 8, ["modelValue", "items"])
                                                              ]),
                                                              _: 1
                                                            }))
                                                          : _createCommentVNode("", true),
                                                        (_ctx.app.type === 'hybrid' && !!_ctx.hybridApps?.length && !_ctx.disabled.length && _ctx.app?.details?.applications?.length)
                                                          ? (_openBlock(), _createBlock(_component_v_col, {
                                                              key: 2,
                                                              cols: "12"
                                                            }, {
                                                              default: _withCtx(() => [
                                                                _createVNode(_component_v_card, {
                                                                  color: "#3c3c3c",
                                                                  class: "pa-4",
                                                                  variant: "flat",
                                                                  style: {"border-bottom":"1px solid rgb(133, 133, 133)","border-radius":"0"},
                                                                  rounded: "t"
                                                                }, {
                                                                  default: _withCtx(() => [
                                                                    _hoisted_2,
                                                                    _createVNode(_component_v_list, { "bg-color": "transparent" }, {
                                                                      default: _withCtx(() => [
                                                                        _createVNode(_component_draggable, {
                                                                          "item-key": "applicationId",
                                                                          list: _ctx.draggedList
                                                                        }, {
                                                                          item: _withCtx(({ element, index }) => [
                                                                            _createVNode(_component_v_list_item, {
                                                                              border: "",
                                                                              class: "mt-1",
                                                                              rounded: "",
                                                                              color: "rgba(0,0,0,0.05)"
                                                                            }, {
                                                                              prepend: _withCtx(() => [
                                                                                _createElementVNode("div", _hoisted_3, [
                                                                                  (_ctx.draggedList.length > 1)
                                                                                    ? (_openBlock(), _createBlock(_component_v_icon, {
                                                                                        key: 0,
                                                                                        style: {"cursor":"pointer"},
                                                                                        class: "mr-2",
                                                                                        color: "primary"
                                                                                      }, {
                                                                                        default: _withCtx(() => [
                                                                                          _createTextVNode("mdi-drag")
                                                                                        ]),
                                                                                        _: 1
                                                                                      }))
                                                                                    : _createCommentVNode("", true)
                                                                                ])
                                                                              ]),
                                                                              append: _withCtx(() => [
                                                                                _createElementVNode("div", _hoisted_4, [
                                                                                  _createVNode(_component_v_avatar, {
                                                                                    rounded: "",
                                                                                    size: "24",
                                                                                    class: "mr-2",
                                                                                    dark: "",
                                                                                    color: "primary",
                                                                                    variant: "tonal"
                                                                                  }, {
                                                                                    default: _withCtx(() => [
                                                                                      _createElementVNode("span", _hoisted_5, _toDisplayString(index + 1), 1)
                                                                                    ]),
                                                                                    _: 2
                                                                                  }, 1024)
                                                                                ])
                                                                              ]),
                                                                              default: _withCtx(() => [
                                                                                _createVNode(_component_v_list_item_title, null, {
                                                                                  default: _withCtx(() => [
                                                                                    _createTextVNode(_toDisplayString(element.name), 1)
                                                                                  ]),
                                                                                  _: 2
                                                                                }, 1024)
                                                                              ]),
                                                                              _: 2
                                                                            }, 1024)
                                                                          ]),
                                                                          _: 1
                                                                        }, 8, ["list"])
                                                                      ]),
                                                                      _: 1
                                                                    }),
                                                                    (_ctx.draggedList.length > 1)
                                                                      ? (_openBlock(), _createElementBlock("p", _hoisted_6, [
                                                                          _createVNode(_component_v_icon, {
                                                                            size: "x-small",
                                                                            start: ""
                                                                          }, {
                                                                            default: _withCtx(() => [
                                                                              _createTextVNode("mdi-information-outline")
                                                                            ]),
                                                                            _: 1
                                                                          }),
                                                                          _createTextVNode("Drag the list items above to order the tabs in your hybrid application")
                                                                        ]))
                                                                      : _createCommentVNode("", true)
                                                                  ]),
                                                                  _: 1
                                                                })
                                                              ]),
                                                              _: 1
                                                            }))
                                                          : _createCommentVNode("", true),
                                                        _createVNode(_component_v_col, { cols: "12" }, {
                                                          default: _withCtx(() => [
                                                            _createVNode(_component_v_textarea, {
                                                              "hide-details": "",
                                                              density: "comfortable",
                                                              label: "Description",
                                                              modelValue: _ctx.app.description,
                                                              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.app.description) = $event))
                                                            }, null, 8, ["modelValue"])
                                                          ]),
                                                          _: 1
                                                        })
                                                      ]),
                                                      _: 1
                                                    })
                                                  ]),
                                                  _: 1
                                                })
                                              ]),
                                              _: 1
                                            }),
                                            _createVNode(_component_v_window_item, { value: "config" }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_ace_editor, {
                                                  value: Object.keys(_ctx.app.details).length ? JSON.stringify(_ctx.app.details, null, 2) : _ctx.appTypes.find((t) => t.type === _ctx.app.type) ? JSON.stringify(_ctx.appTypes.find((t) => t.type === _ctx.app.type).details, null, 2) : '{}',
                                                  "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => {_ctx.disabled = ''; _ctx.updateEditor($event);}),
                                                  lang: "json",
                                                  theme: "chrome",
                                                  style: {"height":"310px"}
                                                }, null, 8, ["value"])
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        }, 8, ["modelValue"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_v_card_actions, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_spacer),
                                        _createVNode(_component_v_tooltip, {
                                          text: _ctx.disabled,
                                          location: "bottom",
                                          "open-delay": "200"
                                        }, {
                                          activator: _withCtx(({ props }) => [
                                            (_ctx.disabled.length)
                                              ? (_openBlock(), _createElementBlock("div", _normalizeProps(_mergeProps({ key: 0 }, props)), [
                                                  _createVNode(_component_v_btn, {
                                                    loading: _ctx.loading,
                                                    disabled: !_ctx.app.name || !_ctx.app.type || _ctx.loading || !!_ctx.disabled.length,
                                                    color: "primary",
                                                    onClick: ($event: any) => {_ctx.registerApp(); isActive.value = false;}
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createTextVNode(" Register application ")
                                                    ]),
                                                    _: 2
                                                  }, 1032, ["loading", "disabled", "onClick"])
                                                ], 16))
                                              : _createCommentVNode("", true)
                                          ]),
                                          _: 2
                                        }, 1032, ["text"]),
                                        (!_ctx.disabled.length)
                                          ? (_openBlock(), _createBlock(_component_v_btn, {
                                              key: 0,
                                              loading: _ctx.loading,
                                              disabled: !_ctx.app.name || !_ctx.app.type || _ctx.loading || (!_ctx.hybridApps.length && _ctx.app.type === 'hybrid') || (!_ctx.noderedInstance?.id && _ctx.app.type === 'nodered'),
                                              color: "primary",
                                              onClick: ($event: any) => {_ctx.registerApp(); isActive.value = false;}
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(" Register application ")
                                              ]),
                                              _: 2
                                            }, 1032, ["loading", "disabled", "onClick"]))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, {
                          cols: "4",
                          md: "auto"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_dialog, {
                              width: "500",
                              modelValue: _ctx.removeDialog,
                              "onUpdate:modelValue": [
                                _cache[14] || (_cache[14] = ($event: any) => ((_ctx.removeDialog) = $event)),
                                _cache[15] || (_cache[15] = ($event: any) => (_ctx.disabled = ''))
                              ]
                            }, {
                              activator: _withCtx(({ props }) => [
                                _createVNode(_component_v_btn, _mergeProps(props, {
                                  size: "small",
                                  width: "220",
                                  variant: "tonal",
                                  disabled: !_ctx.selectedApplications.length,
                                  color: "primary",
                                  onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.currentApplication = _ctx.selectedApplications[0]))
                                }), {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_icon, {
                                      icon: "mdi-close-box",
                                      start: ""
                                    }),
                                    _createTextVNode(" " + _toDisplayString(_ctx.mdAndUp ? 'Remove application' : 'Remove'), 1)
                                  ]),
                                  _: 2
                                }, 1040, ["disabled"])
                              ]),
                              default: _withCtx(() => [
                                _createVNode(_component_v_card, {
                                  "max-width": "460",
                                  loading: _ctx.loading
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_card_title, null, {
                                      default: _withCtx(() => [
                                        _createTextVNode("Remove application")
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_v_card_text, null, {
                                      default: _withCtx(() => [
                                        (!!_ctx.disabled.length)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                                              _hoisted_8,
                                              _createElementVNode("p", _hoisted_9, [
                                                _createVNode(_component_v_btn, {
                                                  color: "primary",
                                                  variant: "tonal",
                                                  to: { name: 'tenants' }
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createTextVNode("Go to tenant management")
                                                  ]),
                                                  _: 1
                                                })
                                              ])
                                            ]))
                                          : _createCommentVNode("", true),
                                        (_ctx.subAppExistsInHybrid)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_10, _hoisted_12))
                                          : (_openBlock(), _createElementBlock("span", _hoisted_13, " Are you sure you want to remove this application? "))
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_v_card_actions, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_spacer),
                                        _createVNode(_component_v_btn, {
                                          onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.removeDialog = false))
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(" Cancel ")
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_v_btn, {
                                          loading: _ctx.loading,
                                          disabled: _ctx.loading || !!_ctx.disabled.length || _ctx.subAppExistsInHybrid,
                                          color: "error",
                                          onClick: _ctx.removeApplication
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(" Remove ")
                                          ]),
                                          _: 1
                                        }, 8, ["loading", "disabled", "onClick"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }, 8, ["loading"])
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_data_table, {
      loading: _ctx.loading,
      color: "primary",
      items: _ctx.applications,
      headers: _ctx.headers,
      "show-select": "",
      modelValue: _ctx.selectedApplications,
      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.selectedApplications) = $event)),
      "select-strategy": "single",
      "items-per-page": "25",
      "return-object": "",
      height: "calc(100vh - 180px)",
      "fixed-header": ""
    }, {
      [`item.type`]: _withCtx(({ item }) => [
        _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.appTypes.find((t) => t.type === item.type).name), 1)
      ]),
      [`item.description`]: _withCtx(({ item }) => [
        (item.description.length > 70)
          ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(_ctx.truncate(item.description)), 1))
          : (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(item.description), 1))
      ]),
      [`item.actions`]: _withCtx(({ item }) => [
        _createVNode(_component_v_btn, {
          width: "80",
          size: "small",
          variant: "tonal",
          color: "primary",
          onClick: ($event: any) => {_ctx.editApplication(item);}
        }, {
          default: _withCtx(() => [
            _createTextVNode("Edit")
          ]),
          _: 2
        }, 1032, ["onClick"])
      ]),
      _: 2
    }, 1032, ["loading", "items", "headers", "modelValue"]),
    _createVNode(_component_v_dialog, {
      width: "500",
      modelValue: _ctx.editDialog,
      "onUpdate:modelValue": [
        _cache[27] || (_cache[27] = ($event: any) => ((_ctx.editDialog) = $event)),
        _cache[28] || (_cache[28] = ($event: any) => {_ctx.tab = 'details'; _ctx.hybridApps = []; _ctx.noderedInstance = null})
      ]
    }, {
      default: _withCtx(({ isActive }) => [
        _createVNode(_component_v_card, { title: "Edit application" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_tabs, {
              modelValue: _ctx.tab,
              "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.tab) = $event))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_tab, { value: "details" }, {
                  default: _withCtx(() => [
                    _createTextVNode("Details")
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_tab, { value: "config" }, {
                  default: _withCtx(() => [
                    _createTextVNode("Configuration")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_window, {
                  modelValue: _ctx.tab,
                  "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.tab) = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_window_item, { value: "details" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_form, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_row, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, {
                                  cols: "12",
                                  md: "6"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_text_field, {
                                      "hide-details": "",
                                      density: "comfortable",
                                      label: "Name",
                                      modelValue: _ctx.currentApplication.name,
                                      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.currentApplication.name) = $event))
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_col, {
                                  cols: "12",
                                  md: "6"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_select, {
                                      class: "text-capitalize",
                                      disabled: "",
                                      "hide-details": "",
                                      density: "comfortable",
                                      label: "Type of application",
                                      modelValue: _ctx.currentApplication.type,
                                      "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.currentApplication.type) = $event)),
                                      "item-title": "name",
                                      "item-value": "type"
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                }),
                                (_ctx.currentApplication.type === 'nodered')
                                  ? (_openBlock(), _createBlock(_component_v_col, {
                                      key: 0,
                                      cols: "12"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_select, {
                                          density: "comfortable",
                                          label: "Node-RED instance",
                                          "return-object": "",
                                          modelValue: _ctx.noderedInstance,
                                          "onUpdate:modelValue": [
                                            _cache[20] || (_cache[20] = ($event: any) => ((_ctx.noderedInstance) = $event)),
                                            _cache[21] || (_cache[21] = ($event: any) => (_ctx.updateConfiguration(_ctx.currentApplication)))
                                          ],
                                          items: _ctx.noderedInstances,
                                          "item-title": "name",
                                          "item-value": "id",
                                          "hide-details": !_ctx.appIsAssignedToTenant,
                                          "persistent-hint": true,
                                          hint: _ctx.appIsAssignedToTenant ? 'This app cannot be modified because it is assigned to a tenant' : '',
                                          disabled: _ctx.appIsAssignedToTenant
                                        }, null, 8, ["modelValue", "items", "hide-details", "hint", "disabled"])
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true),
                                (_ctx.currentApplication.type === 'hybrid')
                                  ? (_openBlock(), _createBlock(_component_v_col, {
                                      key: 1,
                                      cols: "12"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_select, {
                                          "hide-details": !_ctx.appIsAssignedToTenant,
                                          "persistent-hint": true,
                                          hint: _ctx.appIsAssignedToTenant ? 'This app cannot be modified because it is assigned to a tenant' : '',
                                          disabled: _ctx.appIsAssignedToTenant,
                                          multiple: "",
                                          density: "comfortable",
                                          label: "Applications to group",
                                          "return-object": "",
                                          modelValue: _ctx.hybridApps,
                                          "onUpdate:modelValue": [
                                            _cache[22] || (_cache[22] = ($event: any) => ((_ctx.hybridApps) = $event)),
                                            _cache[23] || (_cache[23] = ($event: any) => (_ctx.updateConfiguration(_ctx.currentApplication)))
                                          ],
                                          items: _ctx.hybridAvailableApps,
                                          "item-title": "name",
                                          "item-value": "id"
                                        }, null, 8, ["hide-details", "hint", "disabled", "modelValue", "items"])
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true),
                                (_ctx.currentApplication.type === 'hybrid' && !!_ctx.hybridApps?.length && !_ctx.disabled.length && _ctx.currentApplication?.details?.applications?.length)
                                  ? (_openBlock(), _createBlock(_component_v_col, {
                                      key: 2,
                                      cols: "12"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_card, {
                                          color: "#3c3c3c",
                                          class: "px-4 py-2",
                                          variant: "flat",
                                          style: {"border-bottom":"1px solid rgb(133, 133, 133)","border-radius":"0"},
                                          rounded: "t"
                                        }, {
                                          default: _withCtx(() => [
                                            _hoisted_17,
                                            _createVNode(_component_v_list, { "bg-color": "transparent" }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_draggable, {
                                                  "item-key": "applicationId",
                                                  list: _ctx.draggedList
                                                }, {
                                                  item: _withCtx(({ element, index }) => [
                                                    _createVNode(_component_v_list_item, {
                                                      border: "",
                                                      class: "mt-1",
                                                      rounded: "",
                                                      color: "rgba(0,0,0,0.05)"
                                                    }, {
                                                      prepend: _withCtx(() => [
                                                        _createElementVNode("div", _hoisted_18, [
                                                          (_ctx.draggedList.length > 1)
                                                            ? (_openBlock(), _createBlock(_component_v_icon, {
                                                                key: 0,
                                                                style: {"cursor":"pointer"},
                                                                class: "mr-2",
                                                                color: "primary"
                                                              }, {
                                                                default: _withCtx(() => [
                                                                  _createTextVNode("mdi-drag")
                                                                ]),
                                                                _: 1
                                                              }))
                                                            : _createCommentVNode("", true)
                                                        ])
                                                      ]),
                                                      append: _withCtx(() => [
                                                        _createElementVNode("div", _hoisted_19, [
                                                          _createVNode(_component_v_avatar, {
                                                            rounded: "",
                                                            size: "24",
                                                            class: "mr-2",
                                                            dark: "",
                                                            color: "primary",
                                                            variant: "tonal"
                                                          }, {
                                                            default: _withCtx(() => [
                                                              _createElementVNode("span", _hoisted_20, _toDisplayString(index + 1), 1)
                                                            ]),
                                                            _: 2
                                                          }, 1024)
                                                        ])
                                                      ]),
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_v_list_item_title, null, {
                                                          default: _withCtx(() => [
                                                            _createTextVNode(_toDisplayString(element.name), 1)
                                                          ]),
                                                          _: 2
                                                        }, 1024)
                                                      ]),
                                                      _: 2
                                                    }, 1024)
                                                  ]),
                                                  _: 1
                                                }, 8, ["list"])
                                              ]),
                                              _: 1
                                            }),
                                            (_ctx.draggedList.length > 1)
                                              ? (_openBlock(), _createElementBlock("p", _hoisted_21, [
                                                  _createVNode(_component_v_icon, {
                                                    size: "x-small",
                                                    start: ""
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createTextVNode("mdi-information-outline")
                                                    ]),
                                                    _: 1
                                                  }),
                                                  _createTextVNode("Drag the list items above to order the tabs in your hybrid application")
                                                ]))
                                              : _createCommentVNode("", true)
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true),
                                _createVNode(_component_v_col, { cols: "12" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_textarea, {
                                      "hide-details": "",
                                      density: "comfortable",
                                      label: "Description",
                                      modelValue: _ctx.currentApplication.description,
                                      "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.currentApplication.description) = $event))
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_window_item, { value: "config" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_card, {
                          flat: "",
                          color: "transparent",
                          disabled: _ctx.appIsAssignedToTenant && _ctx.appIsHybrid
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_ace_editor, {
                              readonly: _ctx.appIsAssignedToTenant && _ctx.appIsHybrid,
                              value: JSON.stringify(_ctx.currentApplication.details, null, 2) || '{}',
                              "onUpdate:value": _cache[25] || (_cache[25] = ($event: any) => {_ctx.disabled = ''; _ctx.updateEditor($event);}),
                              lang: "json",
                              theme: "chrome",
                              style: {"height":"310px"}
                            }, null, 8, ["readonly", "value"])
                          ]),
                          _: 1
                        }, 8, ["disabled"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_actions, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_spacer),
                _createVNode(_component_v_tooltip, {
                  text: _ctx.disabled,
                  location: "bottom",
                  "open-delay": "200"
                }, {
                  activator: _withCtx(({ props }) => [
                    (_ctx.disabled.length)
                      ? (_openBlock(), _createElementBlock("div", _normalizeProps(_mergeProps({ key: 0 }, props)), [
                          _createVNode(_component_v_btn, {
                            loading: _ctx.loading,
                            disabled: !_ctx.currentApplication.name || !!_ctx.disabled.length,
                            color: "primary"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" Save application ")
                            ]),
                            _: 1
                          }, 8, ["loading", "disabled"])
                        ], 16))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["text"]),
                (!_ctx.disabled.length)
                  ? (_openBlock(), _createBlock(_component_v_btn, {
                      key: 0,
                      loading: _ctx.loading,
                      disabled: !_ctx.currentApplication.name || _ctx.loading,
                      color: "primary",
                      onClick: ($event: any) => {_ctx.saveApplication(); isActive.value = false;}
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Save application ")
                      ]),
                      _: 2
                    }, 1032, ["loading", "disabled", "onClick"]))
                  : _createCommentVNode("", true)
              ]),
              _: 2
            }, 1024)
          ]),
          _: 2
        }, 1024)
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}